/* global axios */
import ApiClient from './ApiClient';

class ContractsAPI extends ApiClient {
  constructor() {
    super('contracts', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  resolveNumber(number) {
    return axios.get(`${this.url}/resolve_number`, {
      params: { number: number || undefined }
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  update(id, contractData) {
    return axios.patch(`${this.url}/${id}`, { contract: contractData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ContractsAPI();
